import { FC, PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentCompany, useCurrentUser, useIdentity } from '@bonusly/who-am-i';

import { PageLoading } from '../components/loading';

// routes that don't require authentication
const PUBLIC_ROUTE_PREFIXES = ['/labs'];

function isPublicRoute(): boolean {
	return PUBLIC_ROUTE_PREFIXES.some((prefix) => window.location.pathname.startsWith(prefix));
}

export const AppLoading: FC<PropsWithChildren> = ({ children }) => {
	const { isUserIdentified } = useIdentity();
	const company = useCurrentCompany();
	const user = useCurrentUser();
	const { i18n, t } = useTranslation('monarch');

	useEffect(() => {
		const locale = user?.locale || company?.locale;

		if (locale) {
			i18n.changeLanguage(locale);
		}
	}, [company?.locale, i18n, user]);

	// skip loading gate for public routes
	if (!isUserIdentified && !isPublicRoute()) {
		return <PageLoading>{t('loading')}</PageLoading>;
	}

	return <>{children}</>;
};
